interface AuthErrorProps {
  message: string
}

export function AuthError({ message }: AuthErrorProps) {
  return (
    <div className="flex h-screen items-center justify-center bg-(--color-bg-primary)">
      <div className="text-center max-w-sm px-4">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-(--color-danger)/10">
          <svg className="h-6 w-6 text-(--color-danger)" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
        </div>
        <p className="mb-4 text-sm text-(--color-text-secondary)">{message}</p>
        <button
          onClick={() => window.location.reload()}
          className="rounded-md bg-(--color-primary) px-4 py-2 text-sm font-medium text-white hover:bg-(--color-primary-dark) transition-colors"
        >
          Recarregar
        </button>
      </div>
    </div>
  )
}
